import { SiteMetadata } from "./useSiteMetadata";

const commonSchema = (logoPath: string) => {
  return {
    "@context": "https://schema.org",
    publisher: {
      "@type": "Organization",
      name: "DoltHub",
      logo: {
        "@type": "ImageObject",
        url: logoPath,
      },
    },
  };
};

const schemaHomePage = (logoPath: string) => {
  return {
    ...commonSchema(logoPath),
    "@type": "WebPage",
    name: "DoltHub",
    description:
      "DoltHub is where people collaboratively build, manage, and distribute structured data using version controlled Dolt databases - dolthub.com",
  };
};

const schemaBlog = (
  meta: SiteMetadata,
  frontmatter: Queries.BlogPostFrontmatterFragment
) => {
  return {
    ...commonSchema(meta.logoPath),
    "@type": "Article",
    headline: meta.title,
    image: meta.imagePath,
    description: meta.description,
    datePublished: frontmatter.date,
    author: {
      "@type": "Person",
      name: frontmatter.author,
      url: frontmatter.authorHref,
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.dolthub.com/blog",
    },
  };
};

// Reference: https://www.gatsbyjs.com/docs/how-to/adding-common-features/adding-seo-component/#rich-snippets
export default function getRichSnippet(
  meta: SiteMetadata,
  frontmatter?: Queries.BlogPostFrontmatterFragment
): string {
  return JSON.stringify(
    frontmatter ? schemaBlog(meta, frontmatter) : schemaHomePage(meta.imagePath)
  );
}
